module.exports = __webpack_public_path__ + "static/img/notext-stargroup.af9ea0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/notext-stargroup.png
// module id = Bjtc
// module chunks = 1